import { UseCase } from "../../useCase"
import { GetGiftCardsResponse } from "./response"
import { GetGiftCardsRequest } from "./request"
import { GiftCardRepository } from "../../../repositories/GiftCardRepository"

export class GetGiftCardsUseCase implements UseCase<GetGiftCardsRequest, GetGiftCardsResponse> {
	private _repository
	constructor({ GiftCardRepository }: { GiftCardRepository: GiftCardRepository }) {
		this._repository = GiftCardRepository
	}

	exec({ pagination, limit, filter }: GetGiftCardsRequest) {
		return this._repository.getGiftCards(pagination, limit, filter)
	}
}
